<template>
    <b-tabs content-class="mt-3"
            v-model="tab"
            fill
    >
        <b-tab title="Categorías 1 y 2" active>
            <answers ref="answers"
                     code_question_group="GQ10"
                     danger_code="MCAL30"
                     v-if="tab === 0"
            />
        </b-tab>
        <b-tab title="Irritación vías respiratorias">
            <answers ref="answers"
                     code_question_group="GQ11"
                     danger_code="MCAL31"
                     v-if="tab === 1"
            />
        </b-tab>
        <b-tab title="Efectos narcóticos">
            <answers ref="answers"
                     code_question_group="GQ12"
                     danger_code="MCAL32"
                     v-if="tab === 2"
            />
        </b-tab>
    </b-tabs>
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    },
    data(){
        return {
            tab: 0
        }
    }
};
</script>
